import { Text } from "components";
import { WarningCircleIcon } from "components/icons";
import React from "react";
import {
  ServiceItemRightStyle,
  WarningIconStyle,
  InfoItemStyle,
  InfoItemTitleStyle,
  InfoLeftItemStyle,
  LearnMoreStyle,
} from "../styles";

type Props = {
  title: string;
  subtitle: string;
  onClick: () => void;
};
export const InfoItem: React.FC<Props> = ({ title, subtitle, onClick }) => {
  return (
    <div className={InfoItemStyle}>
      <div className={InfoLeftItemStyle}>
        <WarningCircleIcon style={WarningIconStyle} />
        <div className={InfoItemTitleStyle}>
          <Text.BodyXS>{title}</Text.BodyXS>
          <Text.Body2XS color="seconday">{subtitle}</Text.Body2XS>
        </div>
      </div>
      <div className={ServiceItemRightStyle}>
        <button onClick={onClick} className={LearnMoreStyle}>
          Learn more
        </button>
      </div>
    </div>
  );
};
